module.exports = __webpack_public_path__ + "media/images/ui-onboard/easily-editable-code-3c9a66550ca17b9f08f73db3de311f3a.svg";